import IconBrush from '@picsart/icons/IconBrush';
import IconEraser from '@picsart/icons/IconEraser';
import IconInvert from '@picsart/icons/IconInvert';
import IconRefresh from '@picsart/icons/IconRefresh';
import IconBackground from '@picsart/icons/IconBackground';
import { ImageConfig } from '@picsart/web-layering/types';

import generateImageUrl from 'utils/images/generateImageUrl';
import { CDN_130, CDN_140, PA_STATIC } from 'configs/constants';

const EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const ERASER_SIDEBAR_WIDTH = 88;
const ERASER_HEADER_HEIGHT = 62;
const ERASER_SIDEBAR_WIDTH_DARK = 80;
const ERASER_HEADER_HEIGHT_DARK = 56;
const ERASER_SETTINGS_SIDEBAR_WIDTH = 360;
const ERASER_SETTINGS_SIDEBAR_WIDTH_DARK = 340;
const ERASER_LINE_SIZE = 20;
const ERASER_SIDEBAR_DIFF = 112;
const ERASER_PAGE_PADDING = 8;
const ERASER_GAP = 4;
export const ERASER_SIZE_MIN_VALUE = 1;
export const DISTORTION_SKELETON_SIZE = 2;
export const ERASER_FOOTER_HEIGHT = 40;
export const IS_BRUSH_USED = 'is_brush_used';
export const IS_ERASER_USED = 'is_eraser_used';

enum EraserToolsEnum {
  ERASER = 'eraser',
  BRUSH = 'brush',
  CUT_OUT = 'cut-out',
}

enum EraserSettingsEnum {
  OPACITY = 'opacity',
  SIZE = 'size',
  HARDNESS = 'hardness',
}

enum EraserCutoutEnum {
  Object = 'object',
  Person = 'person',
}

enum EraserHistoryToolsEnum {
  INVERT = 'invert',
  RESET = 'reset',
}

export interface IEraserTool {
  name: string;
  type: EraserToolsEnum;
  icon: React.ElementType;
}

export interface IEraserSetting {
  type: EraserSettingsEnum;
  name: string;
  min: number;
  max: number;
  defaultValue: number;
}

export type IEraserImageAttrs = Partial<ImageConfig>;

const eraserToolsNew: IEraserTool[] = [
  {
    name: 'Remove Background',
    type: EraserToolsEnum.CUT_OUT,
    icon: IconBackground,
  },
  {
    name: 'Eraser',
    type: EraserToolsEnum.ERASER,
    icon: IconEraser,
  },
  {
    name: 'Restore',
    type: EraserToolsEnum.BRUSH,
    icon: IconBrush,
  },
];

const historyToolsNew = [
  {
    name: 'Invert',
    type: EraserHistoryToolsEnum.INVERT,
    icon: IconInvert,
  },
  {
    name: 'Reset',
    type: EraserHistoryToolsEnum.RESET,
    icon: IconRefresh,
  },
];

const eraserTools: IEraserTool[] = [
  {
    name: 'Eraser',
    type: EraserToolsEnum.ERASER,
    icon: IconEraser,
  },
  {
    name: 'Restore',
    type: EraserToolsEnum.BRUSH,
    icon: IconBrush,
  },
  {
    name: 'Remove Background',
    type: EraserToolsEnum.CUT_OUT,
    icon: IconBackground,
  },
];

const historyTools = [
  {
    name: 'Invert',
    type: EraserHistoryToolsEnum.INVERT,
    icon: IconInvert,
  },
  {
    name: 'Reset',
    type: EraserHistoryToolsEnum.RESET,
    icon: IconRefresh,
  },
];

const eraserSettingsData: IEraserSetting[] = [
  {
    type: EraserSettingsEnum.OPACITY,
    name: 'Opacity',
    min: 0,
    max: 100,
    defaultValue: 100,
  },
  {
    type: EraserSettingsEnum.SIZE,
    name: 'Size',
    min: 1,
    max: 100,
    defaultValue: ERASER_LINE_SIZE,
  },
  {
    type: EraserSettingsEnum.HARDNESS,
    name: 'Hardness',
    min: 0,
    max: 100,
    defaultValue: 100,
  },
];

const cutoutSettingsData = [
  {
    type: EraserCutoutEnum.Object,
    title: 'OBJECT',
    url: generateImageUrl(`${CDN_130}/328287709092201.png`, 320),
  },
  {
    type: EraserCutoutEnum.Person,
    title: 'PERSON',
    url: generateImageUrl(`${CDN_130}/316184224378201.png`, 320),
  },
];

const cutoutSettingsDataNew = [
  {
    type: EraserCutoutEnum.Person,
    title: 'Person',
    url: generateImageUrl(`${PA_STATIC}/29501240052346529276.png`, 320),
  },
  {
    type: EraserCutoutEnum.Object,
    title: 'Object',
    url: generateImageUrl(`${PA_STATIC}/50317936856183051386.png `, 320),
  },
];

// 1024px
const INVERT_URL = `${CDN_140}/80843616078004038538.png`;

export {
  EMPTY_IMAGE,
  eraserTools,
  historyTools,
  eraserToolsNew,
  historyToolsNew,
  EraserToolsEnum,
  eraserSettingsData,
  EraserSettingsEnum,
  EraserHistoryToolsEnum,
  cutoutSettingsData,
  cutoutSettingsDataNew,
  EraserCutoutEnum,
  ERASER_SIDEBAR_WIDTH,
  ERASER_SIDEBAR_WIDTH_DARK,
  ERASER_HEADER_HEIGHT,
  ERASER_HEADER_HEIGHT_DARK,
  ERASER_SETTINGS_SIDEBAR_WIDTH,
  ERASER_SETTINGS_SIDEBAR_WIDTH_DARK,
  ERASER_LINE_SIZE,
  ERASER_SIDEBAR_DIFF,
  ERASER_PAGE_PADDING,
  ERASER_GAP,
  INVERT_URL,
};
